import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StackedBar from 'legacy-src/utility/StackedBar';
import { stacksToMessage } from 'legacy-src/utility/progressHelpers';
import './index.scss';
import { ANSWER_SHEET_STATUS } from '../../Assignment/answerSheetStatuses';
import { computeAssignmentsToScore } from 'chameleon-src/components/learnosity/utils/helpers';

const { shape, number, bool, string, oneOfType, object } = PropTypes;

class CombinedProgress extends Component {
  static displayName = 'Index';

  static propTypes = {
    progress: shape({
      complete: number.isRequired,
      not_started: number.isRequired,
      scored: number.isRequired,
      scoring: number.isRequired,
      mcq_scoring: number.isRequired,
      started: number.isRequired,
      student_scored: number.isRequired,
      submitted: number.isRequired,
      ready_to_score: number.isRequired,
      no_answer_sheet: number,
      answer_sheet_generated: number,
      answer_sheet_issues: number,
    }).isRequired,
    showLabels: bool,
    isSmall: bool,
    alwaysSmall: bool,
    isLocked: bool,
    message: oneOfType([string, object]),
    showMovedStudentIndicator: bool,
    isPrintAssignment: bool,
  };

  static defaultProps = {
    progress: {},
    showLabels: true,
    isSmall: false,
    alwaysSmall: false,
    isLocked: false,
    message: '',
    showMovedStudentIndicator: false,
    isPrintAssignment: false,
  };

  render() {
    const {
      progress,
      showLabels,
      isSmall,
      isLocked,
      message,
      showMessageOnBar,
      showMovedStudentIndicator,
      isPrintAssignment,
      alwaysSmall,
    } = this.props;
    const notStared = progress.not_started;
    const inProgress = progress.started;
    const availableToScore = computeAssignmentsToScore({
      ...progress,
      readyToScore: progress.ready_to_score,
    });
    const submitted = progress.mcq_scoring;
    const complete =
      progress.complete +
      progress.student_scored +
      progress.scored +
      progress.teacher_and_student_scored;
    const totalStudents = Object.values(progress).reduce(
      (accumulator, current) => accumulator + current,
      0,
    );
    const classHasNoStudents = totalStudents === 0;

    let stacks = [
      {
        status: '--default',
        label: 'Not Started',
        value: notStared,
      },
      {
        status: '--in-progress',
        label: 'In progress',
        value: inProgress,
      },
      {
        status: '--submitted',
        label: 'Submitted',
        value: submitted,
      },
      {
        status: '--available-to-score',
        label: 'Available to score',
        value: availableToScore,
      },
      {
        status: '--complete',
        label: 'Complete',
        value: complete,
      },
    ];

    if (isLocked && showMessageOnBar) {
      stacks = [
        {
          status: '--default',
          label: 'Not Started',
          value: 1,
          text: message,
        },
      ];
    }

    if (isPrintAssignment) {
      stacks = [
        {
          status: ANSWER_SHEET_STATUS.NOT_STARTED,
          label: 'No Answer Sheet',
          value: progress.no_answer_sheet,
        },
        {
          status: ANSWER_SHEET_STATUS.GENERATED,
          label: 'Answer Sheet Generated',
          value: progress.answer_sheet_generated,
        },
        {
          status: ANSWER_SHEET_STATUS.HAS_ISSUES,
          label: 'Answer Sheet Issues',
          value: progress.answer_sheet_issues,
        },
        ...stacks,
      ];
    }

    if (classHasNoStudents) {
      stacks = [
        {
          status: '--default',
          label: 'Not Started',
          value: notStared,
        },
      ];
    }

    return (
      <div
        className="combined_progress"
        aria-label={isLocked && stacksToMessage(stacks, isLocked)}
      >
        <StackedBar
          alwaysSmall={alwaysSmall}
          isSmall={isSmall}
          showLabels={showLabels}
          stacks={stacks}
          showMovedStudentIndicator={showMovedStudentIndicator}
        />
        {isLocked && !showMessageOnBar && (
          <div className="locked_icon">{message}</div>
        )}
      </div>
    );
  }
}

export default CombinedProgress;
